import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BASE_URL from "../config";
//import QRCode from "react-qr-code";
import { FaPrint, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function HallTicket() {
  const { id } = useParams();
const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchHallticket();
  }, []);
useEffect(() => {
  const style = document.createElement("style");

  style.innerHTML = `
    @media print {

      @page {
        size: A4 portrait;
        margin: 8mm;
      }

      body {
        margin: 0;
        padding: 0;
        background: white !important;
      }

      button {
        display: none !important;
      }

      table {
        page-break-inside: avoid;
      }

      h1, h2, h3, p, li {
        margin: 0 !important;
        padding: 0 !important;
      }

      ol {
        margin-top: 8px !important;
      }

      .print-card {
        width: 100% !important;
        max-width: 100% !important;
        box-shadow: none !important;
        border-radius: 0 !important;
        padding: 8px !important;
        margin: 0 !important;
      }

      .print-top {
        margin-bottom: 10px !important;
      }

      .print-instructions {
        margin-top: 10px !important;
        line-height: 1.4 !important;
        font-size: 13px !important;
      }

      .print-signature {
        margin-top: 30px !important;
      }
    }
  `;

  document.head.appendChild(style);

  return () => {
    document.head.removeChild(style);
  };
}, []);
  const fetchHallticket = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/student/hallticket/${id}`
      );

      const result = await response.json();

      if (result.success) {
        setData(result.hallticket);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const printHallticket = () => {
    window.print();
  };
const goHome = () => {
  navigate("/");
};
  if (!data) {
    return <h2>Loading...</h2>;
  }

  return (
    <div style={styles.page}>
    <div style={styles.card} className="print-card">
        {/* TOP */}
     <div style={styles.top}>
  
  {/* LEFT CONTENT */}
  <div style={styles.schoolContainer}>
  
  <h4 style={styles.societyName}>
    ಸೂರ್ಯ ಎಜುಕೇಶನ್ ಸೊಸೈಟಿ(ರಿ)
  </h4>

  <h2 style={styles.heading}>
   ಶ್ರೀ ಪವಾಡ ಬಸವೇಶ್ವರ ಕನ್ನಡ ಹಿರಿಯ ಪ್ರಾಥಮಿಕ ಶಾಲೆ ಹೂವಿನ ಹಿಪ್ಪರಗಿ 
  </h2>

  {/* HORIZONTAL LINE */}
  <div style={styles.line}></div>

  {/* CENTER TITLE */}
  <h3 style={styles.hallTitle}>
   ಉಚಿತ ವಸತಿ ನಿಲಯಕ್ಕೆ ಪ್ರವೇಶ ಪತ್ರ
  </h3>

    <p style={styles.examText}>
      <strong>
        ಪರೀಕ್ಷೆಯ ಸಮಯ[Exam Time]:
      </strong>{" "}
      {data.exam_time}
    </p>

    <p style={styles.examText}>
      <strong>
        ಪರೀಕ್ಷೆ ಕೇಂದ್ರ[Exam Centre]:
      </strong>{" "}
      {data.exam_center}
    </p>
  </div>

  {/* RIGHT PHOTO */}
  <div style={styles.photoSection}>
    <img
      src={`${BASE_URL}${data.photo_path}`}
      alt="student"
      style={styles.photo}
    />
  </div>



       
        </div>

        {/* TABLE */}
        <table style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.tdTitle}>
                ಆಸನ ಸಂಖ್ಯೆ[Seat Number]
              </td>

              <td style={styles.td}>
                {data.id}
              </td>
            </tr>

            <tr>
              <td style={styles.tdTitle}>
                ವಿದ್ಯಾರ್ಥಿಯ ಹೆಸರು - Student's Name
              </td>

              <td style={styles.td}>
                {data.student_name}
              </td>
            </tr>

            <tr>
              <td style={styles.tdTitle}>
                ವಿದ್ಯಾರ್ಥಿಯ ಆಧಾರ ಸಂಖ್ಯೆ - Aadhar Number
              </td>

              <td style={styles.td}>
                {data.aadhar_number}
              </td>
            </tr>

            <tr>
              <td style={styles.tdTitle}>
                ಪ್ರವೇಶಾತಿ ಪಡೆಯುವ ತರಗತಿ - Admission Class for 26-27
              </td>

              <td style={styles.td}>
                {data.admission_class}
              </td>
            </tr>

            <tr>
              <td style={styles.tdTitle}>
                ಪರೀಕ್ಷೆಯ ದಿನಾಂಕ - Exam Date
              </td>

              <td style={styles.td}>
                {new Date(
                  data.exam_date
                ).toLocaleDateString()}
              </td>
            </tr>

            <tr>
              <td style={styles.tdTitle}>
               ಅರ್ಜಿ ಸಲ್ಲಿಸಿದ ದಿನಾಂಕ - Applied Date
              </td>

              <td style={styles.td}>
                {new Date(
                  data.created_at
                ).toLocaleString()}
              </td>
            </tr>
          </tbody>
        </table>

        {/* INSTRUCTIONS */}
        <div
  style={styles.instructions}
  className="print-instructions"
>
          <h3>ಪರೀಕ್ಷೆಯ ಸೂಚನೆಗಳು:</h3>

          <ol>
            <li>
              ಪರೀಕ್ಷೆಗೆ ಹಾಜರಾಗುವ ವಿದ್ಯಾರ್ಥಿಗಳು ಕಡ್ಡಾಯವಾಗಿ ಈ ಪ್ರವೇಶ ಪತ್ರವನ್ನು ಮುದ್ರಿಸಿಕೊಂಡು, ಮುದ್ರಿತ ಪ್ರತಿಯೊಂದಿಗೆ ಹಾಜರಾಗಬೇಕು]
            </li>

            <li>
              ಪರೀಕ್ಷೆಯ ನಿಗದಿತ ಸಮಯಕ್ಕಿಂತ 30 ನಿಮಿಷ ಮುಂಚಿತವಾಗಿ ಪರೀಕ್ಷಾ ಕೇಂದ್ರದಲ್ಲಿ ಹಾಜರಿರಬೇಕು.
            </li>

            <li>
             ಕಡ್ಡಾಯವಾಗಿ ವಿದ್ಯಾರ್ಥಿಯ ಆಧಾರ ಕಾರ್ಡ ಮೂಲಪ್ರತಿ ಮತ್ತು ಕಳೆದ ಸಾಲಿನ ಅಂಕಪಟ್ಟಿಯ ಝರಾಕ್ಸ್ ಪ್ರತಿಯೊಂದಿಗೆ ಪರೀಕ್ಷೆಗೆ ಹಾಜರಾಗಬೇಕು.
            </li>

           {/*  <li>
              Mobile phones are not allowed.
            </li> */}
          </ol>
        </div>

        {/* SIGNATURE */}
       <div
  style={styles.signatureRow}
  className="print-signature"
>
          <div>ಮೂಲ ಆಧಾರ ಕಾರ್ಡ ಪರಿಶಿಲಿಸಿದವರ ಸಹಿ</div>

          <div>ಕೋಠಡಿಯ ಮೇಲ್ವಿಚಾರಕರ ಸಹಿ</div>
        </div>

       {/* BUTTONS */}
<div style={styles.buttonRow}>
  <button
    style={styles.homeBtn}
    onClick={goHome}
  >
    <FaHome />
    Home
  </button>

  <button
    style={styles.printBtn}
    onClick={printHallticket}
  >
    <FaPrint />
    Print Hall Ticket
  </button>
</div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    background: "#f2f2f2",
    minHeight: "100vh",
    padding: 20,
    fontFamily: "Segoe UI",
  },

  topLeft: {
  flex: 1,
  minWidth: 0,
},

hallTitle: {
  marginTop: 0,
  marginBottom: 8,
  fontSize: 24,
  textAlign: "center",
  color: "#0b2d59",
  fontWeight: "700",
  letterSpacing: 1,
},

examText: {
  marginTop: 3,
  marginBottom: 3,
  lineHeight: 1.4,
  fontSize: 14,
},
buttonRow: {
  marginTop: 40,
  display: "flex",
  justifyContent: "center",
  gap: 15,
  flexWrap: "wrap",
},

homeBtn: {
  background: "#198754",
  color: "#fff",
  border: "none",
  padding: "12px 20px",
  borderRadius: 8,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 10,
  fontSize: 15,
  fontWeight: "600",
  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
  transition: "0.3s",
},
  card: {
    maxWidth: 1000,
    margin: "auto",
    background: "#fff",
    padding: 18,
    borderRadius: 10,
    boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
  },

 top: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: 15,
  marginBottom: 15,
},

  heading: {
    color: "#0b2d59",
  },

 photoSection: {
  width: 90,
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-start",
},

 photo: {
  width: 85,
  height: 100,
  objectFit: "cover",
  border: "1px solid #000",
},

  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 20,
  },

  tdTitle: {
    border: "1px solid #000",
    padding: 7,
    fontWeight: "bold",
    width: "35%",
    background: "#f5f5f5",
  },

  td: {
    border: "1px solid #000",
    padding: 10,
  },

  instructions: {
    marginTop: 30,
    lineHeight: 1.5,
    fontSize: 14,
  },

  signatureRow: {
    marginTop: 35,
    display: "flex",
    justifyContent: "space-between",
    fontWeight: "bold",
  },

  printBtn: {
    marginTop: 40,
    background: "#0b2d59",
    color: "#fff",
    border: "none",
    padding: "12px 20px",
    borderRadius: 8,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginLeft: "auto",
    marginRight: "auto",
  },
  schoolContainer: {
  width: "100%",
},

societyName: {
  margin: 0,
  fontSize: 16,
  color: "#333",
  fontWeight: "600",
},

line: {
  width: "100%",
  height: 2,
  background: "#0b2d59",
  marginTop: 6,
  marginBottom: 10,
},
};